/* ============================================================
   Puddi PDP FAQ — batch 6B
   Accordion behavior. Click a question to toggle its answer.
   ============================================================ */
(function () {
  'use strict';

  var items = document.querySelectorAll('.pdp-faq-item');
  items.forEach(function (item) {
    var q = item.querySelector('.pdp-faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      item.classList.toggle('open');
    });
  });
})();
